module.exports = __webpack_public_path__ + "media/images/markers/default_marker-68dec59bb960f6d84ac74f2fef055603.svg";